import { render, staticRenderFns } from "./OtherProducts.vue?vue&type=template&id=33fb3480&scoped=true&"
import script from "./OtherProducts.vue?vue&type=script&lang=js&"
export * from "./OtherProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fb3480",
  null
  
)

export default component.exports